import axios from 'axios'

/**
 * initial state
 */
const state = () => ({})

/**
 * getters
 */
const getters = {}

/**
 * mutations
 */
const mutations = {}

/**
 * actions
 */
const actions = {
  /**
   * Check flood list
   * @param {*} context
   * @param {*} credentials
   * @returns
   */
  async checkFloodList(context, credentials) {
    try {
      const res = await axios.post(process.env.VUE_APP_DISASTER_CHECK_LISTS, credentials)
      console.log(res)

      if (res.status === 200) {
        if (res.data.isSuccess) {
          return true
        } else return false
      } else return false
    } catch (err) {
      console.error(err)
      return false
    }
  },

  /**
   * Check flood feature status
   * @returns Boolean
   */
  async checkFloodFeatureStatus() {
    try {
      const res = await axios.get(process.env.VUE_APP_DISASTER_STATUS)
      console.log(res)

      if (res.status === 200 && res.data.isSuccess) {
        return res.data.data
      }
    } catch (err) {
      console.error(err)
      return false
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
